import { useEffect, useState } from 'react'
import styled from 'styled-components'

export const Icon = ({ name, isActive }: { name: string, isActive?: boolean }) => {
  const [imgSrc, setImgSrc] = useState<string>()

  useEffect(() => {
    try {
      setImgSrc(
        require('../../Assets/Icons/' +
          name.replace(' ', '').toUpperCase() +
          '.svg')
      )
    } catch {
      console.log('no image found')
    }
  }, [])
  return <>{imgSrc && <Image isActive={isActive} src={imgSrc} />}</>
}
const Image = styled.img<{ isActive?: boolean }>`
  max-width: ${({ isActive }) => (isActive ? '200px' : '150px')};
  width: 100%;
  margin: 0 auto;
  // make black and white if not active
  filter: ${(props) => (props.isActive ? 'none' : 'grayscale(50%)')};
  opacity: ${(props) => (props.isActive ? '1' : '.8')};
  transition: all 0.3s cubic-bezier(0.83, 0, 0.17, 1);
`
